import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const TrendingPlants = () => {
  const [plants, setPlants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    fetchTrendingPlants();
  }, []);

  const fetchTrendingPlants = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/products/getallproducts`);
      const allPlants = response.data;

      if (Array.isArray(allPlants) && allPlants.length > 0) {
        const trending = allPlants.sort(() => 0.5 - Math.random()).slice(0, 8);
        setPlants(trending);
      }
    } catch (error) {
      console.error("Error fetching trending plants:", error.response?.data || error);
      setError("Failed to load trending plants.");
    } finally {
      setLoading(false);
    }
  };

  const addToCart = async (productId) => {
    const token = localStorage.getItem("token");
    const userId = sessionStorage.getItem("userid");

    const selectedProduct = plants.find((p) => p._id === productId || p.id === productId);
    if (!selectedProduct) {
      alert("Product not found.");
      return;
    }

    if (!token || !userId) {
      // Guest cart logic
      const guestCart = JSON.parse(localStorage.getItem("guest_cart")) || [];
      const existingIndex = guestCart.findIndex((item) => item.productId === productId);

      if (existingIndex > -1) {
        guestCart[existingIndex].quantity += 1;
      } else {
        guestCart.push({
          productId: selectedProduct._id || selectedProduct.id,
          title: selectedProduct.title,
          price: selectedProduct.price,
          image: selectedProduct.image,
          quantity: 1,
        });
      }

      localStorage.setItem("guest_cart", JSON.stringify(guestCart));
      alert("Product added to cart!");
      return;
    }

    // Logged-in user
    try {
      const payload = {
        userId,
        productId,
        quantity: 1,
      };

      const response = await axios.post(`${API_URL}/api/cart/add`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      alert(response.data?.message || "Product added to cart!");
    } catch (error) {
      console.error("Add to cart error:", error);
      if (error.response?.status === 401) {
        alert("Authentication failed. Please log in again.");
        navigate("/login");
      } else {
        alert("Failed to add product to cart. Please try again.");
      }
    }
  };

  return (
    <div className="p-6 text-center">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">Trending Plants</h2>

      {loading && <p className="text-center text-gray-600">Loading trending plants...</p>}
      {error && <p className="text-red-500 text-center">{error}</p>}

      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
        {plants.map((plant) => (
          <div
            key={plant._id || plant.id}
            className="bg-white border border-gray-300 rounded-lg shadow-md p-4 flex flex-col h-[320px] w-full"
          >
            <Link to={`/product/${plant._id || plant.id}`}>
              <img
                src={
                  plant.image
                    ? plant.image.startsWith("http")
                      ? plant.image
                      : `${API_URL}${plant.image}`
                    : "https://via.placeholder.com/150"
                }
                alt={plant.title}
                className="w-full h-[160px] object-cover rounded-md mb-4 hover:scale-105 transition-transform duration-300"
              />
            </Link>

            <h6 className="text-lg font-semibold text-center text-gray-800">{plant.title}</h6>

            <p
              className={`text-sm text-center font-medium mt-1 ${
                plant.stock > 0 ? "text-green-600" : "text-red-600"
              }`}
            >
              {plant.stock > 0 ? "In Stock" : "Out of Stock"}
            </p>

            {plant.stock > 0 && plant.stock <= 3 && (
              <p className="text-xs text-orange-500 text-center">
                Only {plant.stock} left!
              </p>
            )}

            <div className="mt-auto flex justify-between items-center pt-3">
              <p className="text-gray-600 text-lg font-medium">₹{plant.price}</p>
              <button
                onClick={() => addToCart(plant._id || plant.id)}
                className={`rounded-md px-4 py-2 text-white ${
                  plant.stock > 0 ? "bg-green-500 hover:bg-green-600" : "bg-gray-400 cursor-not-allowed"
                }`}
                disabled={plant.stock <= 0}
                aria-label={`Add ${plant.title} to cart`}
              >
                +
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrendingPlants;
